import { ACCEPT_REQUEST,REJECT_REQUEST } from "../actions/type";

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, { type, payload }) => {
 
    switch (type) {
        case ACCEPT_REQUEST:
          return {
                // ...state,
            acceptRequest:payload
            };
        case REJECT_REQUEST:
             return {
                // ...state,
            rejectRequest:payload
            };
        default:
            return state;
  }

};
